var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 1.33333H5.99998C2.66665 1.33333 1.33331 2.66666 1.33331 5.99999V9.99999C1.33331 13.3333 2.66665 14.6667 5.99998 14.6667H9.99998C13.3333 14.6667 14.6666 13.3333 14.6666 9.99999V8.66666",
    stroke: "#0F1918",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6933 2.01333L5.43998 7.26667C5.23998 7.46667 5.03998 7.86 4.99998 8.14667L4.71331 10.1533C4.60665 10.88 5.11998 11.3867 5.84665 11.2867L7.85331 11C8.13331 10.96 8.52665 10.76 8.73331 10.56L13.9866 5.30667C14.8933 4.4 15.32 3.34667 13.9866 2.01333C12.6533 0.680001 11.6 1.10667 10.6933 2.01333Z",
    stroke: "#0F1918",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 2.76666C10.3867 4.36 11.6333 5.60666 13.2333 6.06",
    stroke: "#0F1918",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.26b45e1989025c0058dc3e48548cd810.svg";
export { ForwardRef as ReactComponent };